export default __webpack_public_path__ + "static/media/avatar-man.099a7300.png";